export interface AchEvent {
  kind: string;
  n?: number;
}

export interface AchDef {
  id: string;
  name: string;
  desc: string;
  check: (ev: AchEvent) => boolean;
}

export const ACH_DEFS: AchDef[] = [
  { id: 'first_kill',   name: 'PREMIER SANG',          desc: 'Éliminer un ennemi',                          check: (e) => e.kind === 'kill' },
  { id: 'combo_10',     name: 'RÉACTION EN CHAÎNE',    desc: 'Atteindre un combo ×10',                      check: (e) => e.kind === 'combo' && (e.n ?? 0) >= 10 },
  { id: 'combo_25',     name: 'MAÎTRE DES COMBOS',     desc: 'Atteindre un combo ×25',                      check: (e) => e.kind === 'combo' && (e.n ?? 0) >= 25 },
  { id: 'wave_5',       name: 'CHEVAUCHEUR',           desc: 'Terminer la vague 5',                         check: (e) => e.kind === 'wave_clear' && (e.n ?? 0) >= 5 },
  { id: 'wave_10',      name: 'CHASSEUR DE DÉCENNIE',  desc: 'Terminer la vague 10',                        check: (e) => e.kind === 'wave_clear' && (e.n ?? 0) >= 10 },
  { id: 'boss_kill',    name: 'TUEUR DE GÉANT',        desc: 'Éliminer un boss',                            check: (e) => e.kind === 'boss_kill' },
  { id: 'gold_pickup',  name: 'TOUCHE DORÉE',          desc: 'Ramasser une arme dorée',                     check: (e) => e.kind === 'gold_pickup' },
  { id: 'ram_kill',     name: 'VITESSE D’ÉPERONNAGE',  desc: '5 éliminations par éperonnage en partie',     check: (e) => e.kind === 'ram_kill' && (e.n ?? 0) >= 5 },
  { id: 'synergy',      name: 'SURFEUR DE SYNERGIE',   desc: 'Activer la synergie d’arme',                  check: (e) => e.kind === 'synergy' },
  { id: 'bash',         name: 'MUR DE LUMIÈRE',        desc: 'Renvoyer 5 balles d’un seul choc',            check: (e) => e.kind === 'bash_reflect' && (e.n ?? 0) >= 5 },
  { id: 'charge',       name: 'SURCHARGÉ',             desc: 'Toucher avec un tir entièrement chargé',      check: (e) => e.kind === 'charge_kill' },
  { id: 'asteroid_50',  name: 'MAÎTRE DES ASTÉROÏDES', desc: 'Détruire 50 astéroïdes',                      check: (e) => e.kind === 'asteroid_kill' && (e.n ?? 0) >= 50 },
  { id: 'campaign',     name: 'VAINQUEUR DE CAMPAGNE', desc: 'Terminer la campagne de 25 vagues',           check: (e) => e.kind === 'victory' },
  { id: 'no_dmg_wave',  name: 'INTOUCHABLE',           desc: 'Terminer une vague sans dégâts',              check: (e) => e.kind === 'no_dmg_wave' },
];

const KEY = 'ns_achievements_pixi';

function loadUnlocked(): Set<string> {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); }
  catch { return new Set(); }
}
function save(set: Set<string>): void {
  localStorage.setItem(KEY, JSON.stringify(Array.from(set)));
}

const unlocked = loadUnlocked();
const eventQueue: AchEvent[] = [];
let popQueue: { name: string; t: number }[] = [];

export function fireAch(ev: AchEvent): void { eventQueue.push(ev); }

export function isUnlocked(id: string): boolean { return unlocked.has(id); }
export function unlockedSet(): Set<string> { return unlocked; }

export function tickAchievements(): { newPops: { name: string; t: number }[] } {
  while (eventQueue.length > 0) {
    const ev = eventQueue.shift()!;
    for (const def of ACH_DEFS) {
      if (unlocked.has(def.id)) continue;
      if (def.check(ev)) {
        unlocked.add(def.id);
        popQueue.push({ name: '🏆 ' + def.name, t: 3 });
      }
    }
  }
  if (popQueue.length > 0) save(unlocked);
  return { newPops: popQueue.splice(0) };
}
